import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { Space, Button, Form } from "@masterteam/mt-design-react";
import { object, string } from "yup";

import { ReactComponent as ApproveIcon } from "../../assets/images/check.svg";
import { ReactComponent as RejectIcon } from "../../assets/images/rejected.svg";
import { ReactComponent as ReturnIcon } from "../../assets/images/return.svg";

import { REQUEST_STATUSES } from "../../configs/enums";
import api from "../../providers/api";
import { addToast } from "../../helpers";

import "./style.scss";

function RequestActionModal({
  closeModal,
  callback,
  intl,
  isApprove,
  isReturn,
  measureItem,
}) {
  const { Field } = Form;

  const validationCommentSchema = (isApprove) => {
    return object().shape({
      comment: isApprove ? string() : string().required(" "),
    });
  };

  const onSubmit = ({ comment }, { setSubmitting }) => {
    const body = {
      RequestID: measureItem.RequestID || measureItem.ID,
      Action: isReturn
        ? REQUEST_STATUSES?.RETURN
        : isApprove
        ? REQUEST_STATUSES?.APPROVED
        : REQUEST_STATUSES?.REJECTED,
      Comments: comment || "",
    };

    api.workflow
      .doAction(body)
      .then((res) => {
        if (res.StatusCode === "Success") {
          addToast.success(
            isReturn
              ? "details.notification.return.message"
              : isApprove
              ? "details.notification.approve.message"
              : "details.notification.rejected.message"
          );
          callback();
          closeModal();
        }
      })
      .catch((error) => {
        console.error({ error });
        addToast.error(error.message, {
          toastId: "get-users-error",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <div className="modal-container d-flex">
      <div className="d-flex header-wrapper">
        {isReturn ? (
          <ReturnIcon className="tab-icon returnIcon" />
        ) : isApprove ? (
          <ApproveIcon className="tab-icon approveIcon" />
        ) : (
          <RejectIcon className="tab-icon rejectIcon" />
        )}

        <div className="title text-bold">
          {isReturn ? (
            <FormattedMessage
              id="kpi-details.confirm-return"
              defaultMessage="kpi-details.confirm-return"
            />
          ) : isApprove ? (
            <FormattedMessage
              id="kpi-details.confirm-approve"
              defaultMessage="kpi-details.confirm-approve"
            />
          ) : (
            <FormattedMessage
              id="kpi-details.confirm-reject"
              defaultMessage="kpi-details.confirm-reject"
            />
          )}
        </div>
      </div>

      <Form
        layout="dynamic"
        onSubmit={onSubmit}
        validationSchema={validationCommentSchema(isApprove)}
        initialValues={{
          comment: "",
        }}
      >
        {({ isSubmitting }) => (
          <>
            <Field
              name="comment"
              type="textarea"
              inputProps={{
                placeholder: intl.formatMessage({
                  id: "kpi-details.comment",
                  defaultMessage: "kpi-details.comment",
                }),
              }}
            />

            <Space size="large" align="center">
              <Button
                loading={isSubmitting}
                variant={isReturn ? "primary" : isApprove ? "success" : "error"}
                type="submit"
              >
                {isReturn ? (
                  <FormattedMessage
                    id="kpi-details.return"
                    defaultMessage="kpi-details.return"
                  />
                ) : isApprove ? (
                  <FormattedMessage
                    id="kpi-details.approve"
                    defaultMessage="kpi-details.approve"
                  />
                ) : (
                  <FormattedMessage
                    id="kpi-details.reject"
                    defaultMessage="kpi-details.reject"
                  />
                )}
              </Button>

              <Button
                variant="dark"
                onClick={() => {
                  closeModal();
                }}
              >
                <FormattedMessage
                  id="kpi-info-cancel"
                  defaultMessage="kpi-info-cancel"
                />
              </Button>
            </Space>
          </>
        )}
      </Form>
    </div>
  );
}

export default injectIntl(RequestActionModal);
